export const oAuthConfigMocks = {
  OAUTH2: '/as/authorization.oauth2?',
  RESPONSE_TYPE: 'response_type',
  RESPONSE_TYPE_VALUE: 'code',
  SCOPE: 'scope',
  SCOPE_VALUE:
    'custapi.companion.read_only custapi.companion.write loyaltyProfileLite.verify.read',
  RESPONSE_MODE: 'response_mode',
  RESPONSE_MODE_VALUE: 'pi.flow',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  CODE_CHALLENGE_METHOD_VALUE: 'S256',
  OAUTH2_USER_CREDENTIALS: '/pf-ws/authn/flows/',
  OAUTH2_TOKEN: '/as/token.oauth2',
  OPEN_ID: '/idp/userinfo.openid',
  GRANT_TYPE: 'grant_type',
  AUTHORIZATION_CODE: 'authorization_code',
  CODE: 'code',
  CODE_VERIFIER: 'code_verifier',
  CLIENT_ID: 'client_id',
  CLIENT_ID_VALUE: 'I1U9LxyHHrXht4Mnap0kjDTU',
  USERNAME_PASSWORD_REQUIRED: 'USERNAME_PASSWORD_REQUIRED',
  COMPLETED: 'COMPLETED',
  PROMPT: 'prompt',
  PROMPT_VALUE: 'login',
  LEVEL_OF_TRUST: 'level_of_trust',
  LEVEL_OF_TRUST_VALUE: '0',
  PERSISTENT_LOGIN_ENABLE: true,
  PERSISTENT_COOKIE_TIMER: 0.01875,
  ENABLE_PING_LOGOUT: true,
  IS_USER_REMEMBERED: 'IS_USER_REMEMBERED',
  ISSUER_PROD: 'https://signin.delta.com',
  LOG_OUT_URL: '/idp/startSLO.ping?TargetResource=',
  REMEMBERED_DEVICE_DETAILS: 'REMEMBERED_DEVICE_DETAILS',
  REMEMBERME_API_FLOW_ENABLE: false,
  SCOPE_VALUE_RM: 'openid',
  SHOULD_REMEMBER_USER: 'SHOULD_REMEMBER_USER',
  VERSION_PARAMETER: 'v',
  VERSION_PARAMETER_VALUE: '1',
  RESUME: 'RESUME',
  PING_DOMAIN: 'https://signin-si.delta.com'
};
